import { PlanPrivilegeStoreType } from '@shared/types/store/plan-privilege.types';
import { create } from 'zustand';

export const planPrivilegeStore = create<PlanPrivilegeStoreType>((set) => ({
  planPrivileges: null,
  updatePlanPrivileges: (planPrivileges) => set({ planPrivileges }),
}));
